/**
 * Hero — центрированная шапка экрана: значок GlowIcon, заголовок и подзаголовок.
 * size="lg" — крупный вариант (стартовый экран), "md" — обычный.
 */
import type { ReactNode } from "react";
import { GlowIcon } from "@/components/GlowIcon";

type Props = {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
  size?: "md" | "lg";
};

export function Hero({ icon, title, subtitle, size = "md" }: Props) {
  const lg = size === "lg";
  return (
    <div className={`flex flex-col items-center text-center ${lg ? "" : "mb-7"}`}>
      <div className={lg ? "mb-7" : "mb-5"}>
        <GlowIcon className={lg ? "h-24 w-24 rounded-[28px]" : "h-16 w-16 rounded-[20px] text-[28px]"}>
          {icon}
        </GlowIcon>
      </div>
      <h1 className={`font-semibold leading-tight ${lg ? "text-[28px]" : "text-[24px]"}`}>{title}</h1>
      {subtitle && (
        <p className={`leading-snug text-white/55 ${lg ? "mt-3 max-w-[19rem] text-[15px]" : "mt-2 text-[14px]"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
